import { BP_ROLE_TYPE } from '../../config/BusinessPartnerConsts'

export type TeamPurposeData = {
  code: string
  description: string
  displayName: string
}

export const PURPOSE_MAP: Record<string, TeamPurposeData> = {
  PRODUCT_DESIGN_DEVELOPMENT: {
    code: 'PRODUCT_DESIGN_DEVELOPMENT',
    description:
      'Sets up this team to work in Products and Workspaces, focused on end-to-end product development.',
    displayName: 'Product Design & Development',
  },
  FABRIC_DEVELOPMENT: {
    code: 'FABRIC_DEVELOPMENT',
    description:
      "Limits the team's work to Fabrics within the Materials library, supporting fabric development and iteration.",
    displayName: 'Fabric Development',
  },
  COLOR_DEVELOPMENT: {
    code: 'COLOR_DEVELOPMENT',
    description:
      'Enables work across Color, Artwork and Combinations in the Materials library, with Combinations also available in Workspaces.',
    displayName: 'Color & Artwork Development',
  },
  TRIM_DEVELOPMENT: {
    code: 'TRIM_DEVELOPMENT',
    description:
      'Focuses this team on Trim within the Materials library, for trim-specific development.',
    displayName: 'Trim Development',
  },
  WASH_DEVELOPMENT: {
    code: 'WASH_DEVELOPMENT',
    description:
      'Focuses this team on Wash within the Materials library, for wash development.',
    displayName: 'Wash Development',
  },
  GENERIC_MATERIALS: {
    code: 'GENERIC_MATERIALS',
    description:
      'Gives this team access to the Materials library to support broader materials development.',
    displayName: 'Materials Development',
  },
  PACKAGING_DEVELOPMENT: {
    code: 'PACKAGING_DEVELOPMENT',
    description:
      'Sets up this team to work in Products and Workspaces, focused on packaging design and development.',
    displayName: 'Packaging Design & Development',
  },
}

const DEFAULT_TEAM_PURPOSE = Object.values(PURPOSE_MAP)

export const getPurpose = (selectedPurpose: string): TeamPurposeData => {
  const purpose = selectedPurpose
    ? DEFAULT_TEAM_PURPOSE.filter((purpose) => purpose.code === selectedPurpose)
    : []
  return purpose[0] || ({} as TeamPurposeData)
}

export const getUserPurpose = ({
  isInternalTeam,
  partnerType,
}: {
  isInternalTeam: boolean
  partnerType: string | number
}) => {
  const currentPartnerType =
    typeof partnerType === 'string' ? Number(partnerType) : partnerType
  if (isInternalTeam) {
    return DEFAULT_TEAM_PURPOSE
  } else {
    switch (currentPartnerType) {
      case BP_ROLE_TYPE.MERCHANDISE_VENDOR:
        return DEFAULT_TEAM_PURPOSE
      case BP_ROLE_TYPE.FABRIC_SUPPLIER:
        return [getPurpose('FABRIC_DEVELOPMENT')]
      case BP_ROLE_TYPE.DESIGN_PARTNER:
        return [
          getPurpose('PRODUCT_DESIGN_DEVELOPMENT'),
          getPurpose('COLOR_DEVELOPMENT'),
          getPurpose('FABRIC_DEVELOPMENT'),
          getPurpose('TRIM_DEVELOPMENT'),
          getPurpose('PACKAGING_DEVELOPMENT'),
        ]
      case BP_ROLE_TYPE.TRIM_SUPPLIER:
        return [getPurpose('TRIM_DEVELOPMENT')]
      case BP_ROLE_TYPE.FRAGRANCE_SUPPLIER:
      case BP_ROLE_TYPE.FOOTWEAR_SUPPLIER:
      case BP_ROLE_TYPE.YARN_SUPPLIER:
        return [getPurpose('GENERIC_MATERIALS')]
      default:
        return []
    }
  }
}
